// Third party
import { combineEpics } from "redux-observable";

// Project
import notificationAddEpic from "./notificationAddEpic";
import notificationDismissDelayedEpic from "./notificationDismissDelayedEpic";

export default combineEpics(notificationAddEpic, notificationDismissDelayedEpic);
